import { render } from "./UploadError.vue?vue&type=template&id=40921f30&ts=true"
import script from "./UploadError.vue?vue&type=script&lang=ts"
export * from "./UploadError.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__